module.exports = __webpack_public_path__ + "img/order_menu.67c6e20f.svg";